import { mixed, object, string } from 'yup';

import { INetworkElementsSFTPPathsDTO } from '@interfaces/networkElements/dto/networkElements';

import { getMaxLengthErrMsg, mandatoryErrMessage } from '@constants/validationConstants';
import { MAX_256_LENGTH } from '@constants/validationMessages';
import { DEFAULT_SFTP_PATH } from '../constants';

import { isNetworkElementError } from './utils';

const pathSchema = ({
	conditionField,
	handleCheckPath,
	id,
	key,
	name,
	additionalPaths,
}: {
	conditionField: string;
	handleCheckPath: (dto: INetworkElementsSFTPPathsDTO) => void;
	id: string;
	key: string;
	name: string;
	additionalPaths: { [key: string]: string | undefined };
}) => mixed()
	.when(conditionField, {
			is: (conditionField: boolean) => conditionField,
			then: string()
				.max(MAX_256_LENGTH, getMaxLengthErrMsg(`SFTP Server Path (${name})`, MAX_256_LENGTH))
				.nullable()
				.required(mandatoryErrMessage(`SFTP Server Path (${name})`))
				.test(key, `Path ${name} is not valid`,
					async (value) => {
						if (!value) return false;

						try {
							await handleCheckPath({
								...additionalPaths,
								[key]: value,
								id,
							});

							return true;
						} catch (err: any) {
							if (isNetworkElementError(err)) {
								return true;
							}

							return false;
						}
					},
				),
			otherwise: string().nullable().required(),
		},
	);

export const pathsSchema = ({
	handleCheckPath,
	id,
	isCuPath,
	isDuPath,
}: {
	handleCheckPath: (dto: INetworkElementsSFTPPathsDTO) => void;
	id: string;
	isCuPath: boolean;
	isDuPath: boolean;
}) => object({
	pathDu: pathSchema({
		conditionField: 'isDuPath',
		handleCheckPath,
		id,
		key: 'pathDu',
		name: 'DU',
		additionalPaths: {
			pathCu: isCuPath ? DEFAULT_SFTP_PATH : undefined,
		},
	}),
	pathCu: pathSchema({
		conditionField: 'isCuPath',
		handleCheckPath,
		id,
		key: 'pathCu',
		name: 'CU',
		additionalPaths: {
			pathDu: isDuPath ? DEFAULT_SFTP_PATH : undefined,
		},
	}),
});
